import Allow from 'components/Allow';
import FilterText from 'components/FilterText';
import { useMainContext } from 'context/MainContext';
import { enumRules } from 'enum/enumRules';
import { IProductType } from 'interfaces/IProduct';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useProductTypeService } from 'services/productTypeService';
import { Delete, Edit } from 'styled-icons/material';
import * as S from './style';

const TableProductTypes: React.FC = () => {
  const navigate = useNavigate();
  const { setDialog } = useMainContext();
  const { productTypeService } = useProductTypeService();
  const [productTypes, setProductTypes] = useState<IProductType[] | null>(null);
  const getData = useCallback(async () => {
    try {
      const { ProductTypes } = await productTypeService.getAll();
      setProductTypes(ProductTypes);
    } catch (error) {
      console.log(
        `error in TableProductTypes - function getData, error:${error}`
      );
    }
  }, [productTypeService]);
  const handleConfirm = useCallback(
    async (productId: number) => {
      try {
        await productTypeService.destroy(productId);
        const { ProductTypes } = await productTypeService.getAll();
        setProductTypes(ProductTypes);
      } catch (error) {
        console.log(
          `error in TableProductTypes - function handleConfirm, error:${error}`
        );
      }
    },
    [productTypeService]
  );
  const handleDelete = (productTypeId: number) => {
    setDialog({
      show: true,
      callBackConfirm: () => handleConfirm(productTypeId),
      textBody: 'Esta ação é irreversível, tem certeza que deseja prosseguir ?'
    });
  };
  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <S.Container>
      <FilterText
        placeholderInput="Id ou Nome..."
        nameFieldToFilter="Name,Id"
        dataToFilter={productTypes}
        setDataToFilter={setProductTypes}
      />
      {productTypes && productTypes.length > 0 && (
        <Row>
          <Col>
            <div className="table-thead-fixed">
              <Table className="table-striped text-center" responsive>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {productTypes.map((productType: IProductType) => (
                    <tr key={productType.Id}>
                      <td>{productType.Id}</td>
                      <td>{productType.Name}</td>

                      <td>
                        <Allow
                          ruleId={enumRules.ProductType.CanWriteProductType}
                        >
                          <Button
                            onClick={() =>
                              navigate('AddEditProductType', {
                                state: productType
                              })
                            }
                            variant="outline-primary"
                          >
                            <Edit title="Editar" size={22} />
                          </Button>
                          <Button
                            style={{ margin: 5 }}
                            onClick={() => handleDelete(productType.Id)}
                            variant="outline-primary"
                          >
                            <Delete title="Excluir" size={22} />
                          </Button>
                        </Allow>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </S.Container>
  );
};

export default TableProductTypes;
